import React from "react";
import { FileUpload } from "./FileUpload";
import type { TemplateFormName } from "../types";

const TEMPLATE_LABELS: Record<TemplateFormName, string> = {
  "school-certification": "School Certification Form",
  "physician-statement": "Physician's Statement / Physical Exam Form",
  "asthma-action-plan": "Asthma Action Plan",
  "medication-authorization": "Physician Medication Authorization Form",
  "financial-responsibility": "Agreement of Financial Responsibility",
  "liability-waiver": "Release and Waiver of Liability Agreement",
};

export function TemplateUpload({
  templateName,
  fieldKey,
  helper,
  required = true,
}: {
  templateName: TemplateFormName;
  fieldKey: string;
  helper: string;
  required?: boolean;
}) {
  const label = TEMPLATE_LABELS[templateName];
  return (
    <div className="rounded-md border border-program/30 bg-program/5 p-4">
      <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
        <div className="min-w-0">
          <p className="font-medium text-slate-900">
            {label} {required && <span className="text-red-600">*</span>}
          </p>
          <p className="text-xs text-slate-700 mt-1">{helper}</p>
        </div>
        <a
          href={`/templates/${templateName}.pdf`}
          download
          className="btn-secondary text-xs whitespace-nowrap"
        >
          Download Template
        </a>
      </div>
      <FileUpload
        fieldKey={fieldKey}
        label="Upload completed form"
        accept=".pdf,.jpg,.jpeg,.png"
        required={required}
      />
    </div>
  );
}
